import {useBlockTxs} from "../queries";
import QueryProcessor from "./QueryProcessor";
import {CardContent} from "@mui/material";
import TxList from "./TxList";

interface BlockTxListProps {
    blockHeight: number;
}

function BlockTxList({ blockHeight }: BlockTxListProps) {
    const blockTxsQuery = useBlockTxs(blockHeight);
    return (
        <QueryProcessor
            query={blockTxsQuery}
            dataValidator={(data: any) => data.type === 'blocktxs'}
            renderer={(data: any) => (
                <>
                    <CardContent>
                        <TxList data={data.payload} />
                    </CardContent>
                </>
            )}
        />
    );
}
export default BlockTxList;